import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAirModal } from '@air/provider-modal';
import { useShortIdContext } from '@air/provider-short-id';

import { SharePublicClipModal } from '~/components/Modals/SharePublicClipModal';
import { centralizedClipSelector } from '~/store/centralizedClip/selectors';
import { getPublicClipShareUrl } from '~/swr-hooks/shortUrl/utils';

export const usePublicClipAssetShare = () => {
  const [sharePublicClip] = useAirModal(SharePublicClipModal);
  const { shortId } = useShortIdContext();
  const clip = useSelector(centralizedClipSelector);

  const sharePublicClipAsset = useCallback(() => {
    sharePublicClip({
      id: clip.id,
      url: getPublicClipShareUrl(shortId),
      trackLocation: 'public-asset-page',
    });
  }, [clip.id, sharePublicClip, shortId]);

  return { sharePublicClipAsset };
};
